import React from 'react';

export default props => (
  <button className={props.className} onClick={props.onClick}>
    {props.value}
  </button>
)



// WEBPACK FOOTER //
// ./src/components/Button.js